// extracted by mini-css-extract-plugin
export var active = "w_bd";
export var arrow = "w_9";
export var icon = "w_bz";
export var link = "w_by";
export var links = "w_cy";
export var otherLink = "w_cz";
export var title = "w_g";